import Rest from '../Rest'

export default class DocumentTypeService extends Rest {
  /**
   * @type {String}
   */
  static resource = '/api/v1/document_types'

  static build(vs: any = null) {
    return new this(this.resource, null, vs)
  }
}
